import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import React from 'react'

import { calculateImpressionsFromBudget } from '../../../../UploadAdCreative/ImpressionsBudgetSection/helpers'

import { rightSelector } from '../../../../../../modules/selectors/rights'

import { AMOUNT_MICROS, BUDGET_DAILY, CAMPAIGN_BUDGET } from '../../../../CampaignForms/fields'

const ImpressionsBudgetDailySectionPreview = ({ campaign }) => {
  const { t } = useTranslation()
  const { bid_cap: rightBidCap } = useSelector(rightSelector)

  const impressions = calculateImpressionsFromBudget({
    budget: campaign?.[BUDGET_DAILY] || campaign?.[CAMPAIGN_BUDGET]?.[AMOUNT_MICROS],
    rightBidCap
  })

  return (
    <p>
      {impressions} ({t('Daily')})
    </p>
  )
}

export default ImpressionsBudgetDailySectionPreview
